<template>
  <Dialog header="Ajout d'un membre " class="multi" :closeOnEscape="false" :dismissableMask="false" :closable="false" :modal="true" :visible.sync="openModal"
          height="50px" width="50px">
    <div>
      <p class="mb-3">Pour ajouter un utilisateur à un groupe, celui-ci doit avoir été ajouté au projet et avoir accepté l'invitation.
        Vous pouvez gérer les utilisateurs via <a class="underline" :href="`/projects/${project_id}/settings`">les paramètres du projet.</a></p>
      <multiselect :showLabels="false" class="multiStyle" placeholder="Cliquez pour sélectionner un participant"
                  @remove="removeMembers" v-model="members" :multiple="true" :taggable="false"
                  :options="usersList" label="username"
      >
        <template slot="option" slot-scope="props">
          <p><strong> {{ props.option.username }} </strong>({{ props.option.email }}) </p>
        </template>
        <template slot="noOptions" slot-scope="props">
          <p>Pas de membre à ajouter !</p>
        </template>
      </multiselect>
    </div>
    <template #footer>
      <div class="p-grid">
        <Button
          label="Annuler"
          icon="mdi-close"
          @click="close"
        />
        <Button
          class="buttonAddUser"
          label="Ajouter"
          @click="addUser"
          icon="mdi-plus"
          autofocus
        />
      </div>
    </template>
  </Dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {
  mapGetters
} from 'vuex'

export default {
  components: {
    Multiselect
  },
  props: {
    openModal: Boolean,
    usersList: Array,
    group: Object,
    project_id: Number
  },
  data() {
    return {
      members: [],
    }
  },
  methods: {
    removeMembers(option, id) {
      var index = this.members.findIndex(it => it.id === option.id)
      if (index >= 0) {
        this.members.splice(index, 1)
      }
    },
    addUser() {
      let members = []
      this.members.forEach((element) => {
        members.push({user_id: element.id})
      })
      this.$store.dispatch('users/addUsersToGroup', {
        group_id: this.group.id,
        members: {members: members}
      }).then((r) => {
        this.close()
        this.members = []
        this.$store.dispatch('projects/get_project', this.$route.params.idProject)
          .then((project) => {
            this.$emit('projectUpdate', project)
          })
        this.$emit('groupDescriptionUpdate', this.group.id)
      })
    },
    close() {
      this.$emit('close')
    },
    changeModal() {
      this.$emit('changeModal')
    },
  },
  computed: {}
}
</script>

<style>
</style>
